import { config as shopsConfig } from './shops.config';
import { config as aboutYouConfig } from './about-you.config';
import { config as reviewConfig } from './review.config';
import { config as pathConfig } from './path.config';
import { config as completeConfig } from './complete-page.config';
import { config as selectDateConfig } from './select-date.config';
import { PROGRESS_BAR_ITEMS } from './progress-bar-items.config';
import { getAppointmentsDetails, getAnalyticsData } from './analytics.config';
import { PartnersGroupsDropdown } from '../components';
import { ChosenPartner, ChosenPartnerDropdown } from '~/components';
import { config as errorConfig } from './error-handler.config';
import { config as redirectionConfig } from './redirections.config';
import { services } from '../../services.constant';

const questionsSectionsConfig = [
  {
    key: undefined,
    title: '',
    displayQuestionsInYourDetails: true,
    dataTest: 'YourDetails',
  },
];

export const config = {
  ...shopsConfig,
  ...pathConfig,
  ...aboutYouConfig,
  ...reviewConfig,
  ...completeConfig,
  ...selectDateConfig,
  ...redirectionConfig,
  serviceName: services.BEAUTY.name,
  PROGRESS_BAR_ITEMS,
  getAppointmentsDetails,
  getAnalyticsData,
  chosenPartner: ChosenPartner,
  chosenPartnerDropdown: ChosenPartnerDropdown,
  groupsDropdown: PartnersGroupsDropdown,
  partnerTitle: 'Beauty Therapist',
  hidePartnerPrefix: true,
  hidePartnerDescription: true,
  hidePartnerNameUnderline: true,
  questionsSectionsConfig,
  isPartnerSelectionEnabled: true,
  firstPageNotRequiredToken: true,
  breadcrumb: {
    text: '',
    to: '',
  },
  headlineTitle: 'Beauty',
  errorConfig,
  timeSlotSectionTitle: 'Treatment',
};
